import React, { useEffect, useRef, useState } from 'react'
import { apiGet, apiPost, apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import ErrorMessage from '../../components/ErrorMessage'
import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'
import FormData from 'form-data'
import UserImage from '../../assets/images/defaultUserImage.png'
import { AiFillCamera } from 'react-icons/ai'
import OImage from 'components/reusable/OImage'
import { isEmpty } from 'lodash'
import ODatePicker from 'components/shared/datePicker/ODatePicker'
import dayjs from 'dayjs'
import ReactQuill from 'react-quill'
import { validationRules } from 'utils/constants'
import { BsFileEarmarkPdfFill } from 'react-icons/bs'

const ServiceProviderModal = ({ onHide, getServiceProvider, editData, setPage }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({ mode: 'onBlur', shouldFocusError: true, defaultValues: {} })
  const [logoError, setLogoError] = useState('')
  const [pdfError, setPDFError] = useState('')
  const [logo, setLogo] = useState(null)
  const [pdf, setPDF] = useState(null)
  const [date, setDate] = useState(editData?.newsDate ?? null)

  const [isError, setIsError] = useState(false)
  const [isImageError, setIsImageError] = useState(false)
  const [description, setDescription] = useState(editData?.description ?? '')
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const logoRef = useRef()

  const validateFiles = (logo) => {
    let picError = ''
    const supportedTypes = ['image/jpeg', 'image/jpg', 'image/png']

    if (!isEmpty(supportedTypes.includes(logo.type))) {
      picError = t('VALIDATION_IMAGE_FORMAT')
    }

    if (picError) {
      setLogoError(picError)
      return false
    } else {
      setLogoError('')
      return true
    }
  }

  const getCategories = async () => {
    const path = apiPath.categoryList;
    const result = await apiGet(path);
    if (result?.status === 200) {
      const response = result?.data?.results;
      const cate = response?.docs?.map((item, i) => {
        return {
          key: item?.title,
          value: item?._id,
        };
      });
      setCategories(response?.docs);
    }
  };
  const getServices = async () => {
    const path = apiPath.serviceList;
    const result = await apiGet(path);
    if (result?.status === 200) {
      const response = result?.data?.results;
      const cate = response?.map((item, i) => {
        return {
          key: item?.name,
          value: item?._id,
        };
      });
      setServices(response);
    }
  };
  useEffect(() => {
    getCategories();
    getServices()
  }, []);

  const handleFileChange = (e) => {
    setIsImageError(false)
    const image = e?.target?.files[0]
    const isValidImage = validateFiles(image)
    if (isValidImage) {
      setLogo(image)
    } else {
      setLogo(null)
    }
  }

  const handlePDFFileChange = (e) => {
    setIsError(false)
    const pdf = e?.target?.files[0]
    const isValidPDF = validateFiles(pdf)
    if (isValidPDF) {
      setPDF(pdf)
    } else {
      setPDF(null)
    }
  }
  useEffect(() => {
    if (Object.keys(editData).length !== 0 && editData !== undefined) {
      setValue('name', editData.name ?? '')
      setValue('description', editData.description ?? '')
      setValue('countryCode', editData.countryCode ?? '')
      setValue('mobile', editData.mobile ?? '')
      setValue('pdf', editData.pdf ?? '')
      setValue('categoryId', editData.category?._id ?? '')
      setValue('serviceId', editData.service?._id ?? '')
    }
  }, [editData])
  const handleDateChange = (date) => {
    setIsError(false)
    setDate(date)
  }
  const checkFields = () => {
    let isValid = true
    if (!editData?.logo) {
      if (!logo) {
        setIsImageError(true)
        isValid = false
      }
    } else {
      setIsImageError(false)
    }
    if (!editData?.pdf) {
      if (!pdf) {
        setIsError(true)
        isValid = false
      }
    } else {
      setIsError(false)
    }
    return isValid
  }
  const handleSubmitForm = async (data) => {
    if (Object.keys(editData).length === 0) {
      try {
        const isValid = checkFields()
        if (!isValid) return
        const formData = new FormData()
        if (logo) formData.append('logo', logo)
        if (pdf) formData.append('pdf', pdf)
        if (data.name) formData.append('name', data.name)
        if (data.description) formData.append('description', data.description)
        if (data.categoryId) formData.append('category', data.categoryId)
        if (data.serviceId) formData.append('service', data.serviceId)
        if (data.mobile) formData.append('mobile', data.mobile)
        if (data.countryCode) formData.append('countryCode', data.countryCode)
        // console.log('formData: ', formData);return false
        const res = await apiPost(apiPath.serviceProviderAdd, formData)
        if (res.data.success === true) {
          setPage(1)
          getServiceProvider()
          onHide()
          notification.success(res.data.message)
        } else {
          notification.error(res?.data.message)
        }
      } catch (err) {
        console.log('err:', err)
      }
    } else {
      try {
        const isValid = checkFields()
        if (!isValid) return
        const formData = new FormData()
        if (logo) formData.append('logo', logo)
        if (pdf) formData.append('pdf', pdf)
        if (data.name) formData.append('name', data.name)
        if (data.description) formData.append('description', data.description)
        if (data.categoryId) formData.append('category', data.categoryId)
        if (data.serviceId) formData.append('service', data.serviceId)
        if (data.mobile) formData.append('mobile', data.mobile)
        if (data.countryCode) formData.append('countryCode', data.countryCode)
        const res = await apiPut(apiPath.serviceProviderEdit + '/' + editData._id, formData)
        if (res.data.success === true) {
          getServiceProvider()
          onHide()
          notification.success(res.data.message)
        } else {
          notification.error(res?.data.message)
        }
      } catch (err) {
        console.log('err:', err)
      }
    }
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <form className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]' onSubmit={handleSubmit(handleSubmitForm,
              () => {
                const isValid = checkFields()
                if (!isValid) return
              })}>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('O_VIEW')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => onHide()}
                >
                  <span
                    className=' text-[#B8BBBF]  text-4xl '
                    title={t('O_CLOSE')}
                  >
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div>
                  <div className='py-4 flex justify-center'>
                    <div className='relative w-28 h-28 '>
                      <label className='block mb-2  text-sm font-medium text-gray-900 dark:text-white '>
                        {/* {t('O_IMAGE')}<span className='text-red-500'>*</span> */}
                      </label>
                      <input
                        disabled
                        type='file'
                        accept='image/png, image/jpg, image/jpeg'
                        name='logo'
                        ref={logoRef}
                        onChange={handleFileChange}
                        className='hidden'
                      />
                      <OImage
                        src={
                          logo
                            ? URL.createObjectURL(logo)
                            : editData?.logo ?? UserImage
                        }
                        fallbackUrl={UserImage}
                        className='w-24 h-24'
                        alt=''
                        style={{ borderRadius: '50%' }}
                      />
                    </div>
                  </div>
                  <div className='text-center'>
                    {isImageError ? <ErrorMessage message={t('VALIDATION_NEWS_IMAGE_REQUIRED')} /> : <ErrorMessage message={logoError} />}
                  </div>
                </div>
                <div className='grid grid-cols-2'>

                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='text'
                        name='name'
                        disabled
                        id='name'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        // maxLength={40}
                        {...register('name', {
                          required: t('VALIDATION_NAME_REQUIRED'),
                          pattern: {
                            value: validationRules.characters,
                            message: t('INVALID_NAME')
                          },
                          validate: value => {
                            const val = value.trim()
                            return val.length < 3
                            ? t('VALIDATION_NAME_MIN_LENGTH')
                            : val.length > 50
                            ? t('VALIDATION_NAME_MAX_LENGTH') : true
                          }
                        })}
                        onChange={(event) => {
                          var value = event.target.value;
                          value = value.trimStart()
                          setValue('name', value, { shouldValidate: true })
                        }}
                      />
                      <label
                        for='name'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_NAME')}<span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.name?.message} />
                    </div>
                  </div>
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                    <div className="flex z-0 w-full group items-center">
                    {/* <span>{t('O_PDF')} :</span> */}
                    <a href={editData?.pdf} target="_blank" rel="noreferrer"><BsFileEarmarkPdfFill className="text-black text-5xl"/></a>
                    </div>
                  </div>
                </div>
                <div className='grid grid-cols-2'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                    <input
                    type='number'
                    id='countryCode'
                    disabled
                    className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                    placeholder=' '
                    // onInput={(e) => preventMax(e)}
                    onKeyDown={(e) => {
                      if (['-', '+', 'e'].includes(e.key)) {
                        e.preventDefault()
                      }
                    }}
                    {...register('countryCode', {
                      required: t('VALIDATION_COUNTRY_CODE_REQUIRED'),
                      minLength: {
                        value: 1,
                        message: t('VALIDATION_COUNTRY_CODE_MIN_LENGTH')
                      },
                      maxLength: {
                        value: 4,
                        message: t('VALIDATION_COUNTRY_CODE_MAX_LENGTH')
                      },
                      pattern: {
                        value: validationRules.numbers,
                        message: t('INVALID_COUNTRY_CODE')
                      },
                      validate: value => {
                        return value[0] === '0' ? t('COUNTRY_CODE_ZERO_VALIDATION') : true
                      }
                    })}
                  />
                  <ErrorMessage message={errors?.countryCode?.message} />
                      <label
                        for='countryCode'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_COUNTRY_CODE')}<span className='text-red-500'>*</span>
                      </label>
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                    <input
                    type='number'
                    id='mobile'
                    disabled
                    className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                    placeholder=' '
                    // onInput={(e) => preventMax(e)}
                    onKeyDown={(e) => {
                      if (['-', '+', 'e'].includes(e.key)) {
                        e.preventDefault()
                      }
                    }}
                    {...register('mobile', {
                      required: t('VALIDATION_MOBILE_REQUIRED'),
                      minLength: {
                        value: 9,
                        message: t('VALIDATION_MOBILE_MIN_LENGTH')
                      },
                      maxLength: {
                        value: 15,
                        message: t('VALIDATION_MOBILE_MAX_LENGTH')
                      },
                      pattern: {
                        value: validationRules.numbers,
                        message: t('INVALID_MOBILE')
                      },
                      validate: value => {
                        return value[0] === '0' ? t('MOBILE_ZERO_VALIDATION') : true
                      }
                    })}
                  />
                  <ErrorMessage message={errors?.mobile?.message} />
                      <label
                        for='mobile'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_MOBILE_NUMBER')}<span className='text-red-500'>*</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className='grid grid-cols-1'>
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                    <div className="relative z-0 w-full group">
                        <select
                        id="categoryId"
                        name="categoryId"
                        disabled
                        className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        {...register("categoryId", {
                            required: t("VALIDATION_SELECT_CATEGORY"),
                        })}
                        >
                        <option defaultValue value="">
                            {t("SELECT_CATEGORY")}
                        </option>
                        {categories &&
                            categories.length !== 0 &&
                            categories?.map(({ title, _id }) => (
                                <option
                                key={_id}
                                value={_id}
                                selected={_id === editData?.category?._id}
                                >
                                    {title}
                                </option>
                                ))}
                        </select>
                        <label
                        htmlFor="name"
                        className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                        {t("O_CATEGORY")}
                        <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.categoryId?.message} />
                    </div>
                  </div>
                </div>
                <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                <div className="relative z-0   w-full group">
                <textarea
                  type="text"
                  name="description"
                  disabled
                  id="description"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("description", {
                    required: t("VALIDATION_DESCRIPTION_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_DESCRIPTION_MIN_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("description", value, {
                      shouldValidate: true,
                    });
                  }}
                />
                <label
                  htmlFor="description"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_DESCRIPTION")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.description?.message} />
              </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal uppercase px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => onHide()}
                >
                  {t('O_CLOSE')}
                </button>
                {/* <button
                  className='bg-LightBlue text-white active:bg-emerald-600 font-normal uppercase text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                  type='submit'
                >
                  {editData && Object.keys(editData)?.length ? t('O_EDIT') : t('O_ADD')}
                </button> */}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default ServiceProviderModal
